import { Flex, Icon, Center, Button } from '@chakra-ui/react';
import { NotificationCard } from '../components/Card';
import { NotificationTime } from '../components/Time';
import { decode } from 'js-base64';
import { NotificationLink } from '../components/NotificationLink';
import { useMarkAsReadMutation } from '@/store/query/notification';
import { KText } from '@/ui-library/components';
import { CheckCircle } from '@kula-ai/icons-core';

const ApplicationExport = ({ notification, onClose }) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));
  const [markAsRead] = useMarkAsReadMutation();
  const { job_name, job_url, csv_export_url, records_count } = data || {};
  const jobId = job_url ? job_url.split('/').pop() : undefined;

  return (
    <NotificationCard notification={notification}>
      <Flex alignItems="baseline" gap="6px">
        <Center
          minW="34px"
          h="34px"
          borderRadius="sm"
          bg="pastel-2-light"
          color="pastel-2-dark"
        >
          <Icon as={CheckCircle} width="16px" />
        </Center>
        <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start">
          <KText>Candidate data export is ready to be downloaded</KText>

          <Flex alignItems="baseline">
            <KText size="sm-bold" color="secondary-900">
              Job:
            </KText>
            {jobId ? (
              <KText color="primary-600" size="sm-bold">
                <NotificationLink
                  to={`/jobs/${jobId}`}
                  label={job_name}
                  onClose={onClose}
                  notification={notification}
                  data-test-id="job-link"
                />
              </KText>
            ) : (
              <KText size="sm">{job_name}</KText>
            )}
          </Flex>

          <Flex alignItems="baseline">
            <KText size="sm-bold" color="secondary-900">
              Candidates:
            </KText>
            <KText size="sm" p="0 4px">
              {records_count}
            </KText>
          </Flex>

          <NotificationTime notification={notification} />

          <Button
            w="fit-content"
            variant="primary"
            borderRadius="8px"
            onClick={() => {
              markAsRead({ id: notification?.id });
              if (csv_export_url) {
                try {
                  // Try to parse as full URL first
                  let exportId;
                  try {
                    const url = new URL(csv_export_url);
                    exportId = url.pathname.split('/').pop();
                  } catch {
                    // If not a valid URL, assume it's just the path
                    exportId = csv_export_url.split('/').pop();
                  }

                  // Navigate to local route
                  window.location.href = `/csv-exports/${exportId}`;
                } catch (error) {
                  console.error(
                    'Error parsing CSV export URL:',
                    error,
                    csv_export_url
                  );
                  // If everything fails, try to extract ID from string
                  const parts = csv_export_url.split('/');
                  const exportId = parts[parts.length - 1];
                  if (exportId) {
                    window.location.href = `/csv-exports/${exportId}`;
                  }
                }
              }
            }}
            maxH="34px"
            data-test-id="download-csv-button"
          >
            Download CSV
          </Button>
          <KText>For security purposes this link will expire in 7 days.</KText>
        </Flex>
      </Flex>
    </NotificationCard>
  );
};

export default ApplicationExport;
